import script from "./GameRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./GameRoom.vue?vue&type=script&setup=true&lang=js"

import "./GameRoom.vue?vue&type=style&index=0&id=306c5df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306c5df2"]])

export default __exports__